import generateAdjustedEventTraits from 'src/js/modules/element-settings/helpers/generate-adjusted-event-traits';
import generateModifiedEventTraits from 'src/js/modules/element-settings/helpers/generate-modified-event-traits';
import { PADDINGS } from '../settings/paddings';
import { GAPS } from '../settings/gaps';

const getSpacingAdjustedEventTraits = ({ eventTraitPrefix }) =>
  generateAdjustedEventTraits(eventTraitPrefix, 'Spacing');

const getSpacingModifiedEventTraits = ({ eventTraitPrefix, attribute, newValue, oldValue }) => {
  const attrRelatedOptionId = Object.values({
    ...PADDINGS,
    ...GAPS,
  }).find(({ attributes }) => attributes.includes(attribute)).id;

  return generateModifiedEventTraits(eventTraitPrefix, attrRelatedOptionId, oldValue, newValue);
};

export { getSpacingAdjustedEventTraits, getSpacingModifiedEventTraits };
